import { ClipLoader } from 'react-spinners'
import Styled from './loading.module.css'

function Loading() {
    return (
        <section className={Styled.loading}>
            <ClipLoader color="#fff" size={60} />
        </section>
    )
}

export default Loading